// 04-일반사용자-계정-추가-설계서.md §5: 로그인한 사용자 정보(계정 id/역할)를 모듈 전역으로 보관.
// main.ts가 /api/auth/session 조회 후 채우고, layout.ts(배지)/pages/account.ts(role 분기)가 읽는다.
export interface CurrentUser {
  username: string;
  jatemUserId: string;
  role: "ADMIN" | "USER";
}

let currentUser: CurrentUser | null = null;

export function setCurrentUser(user: CurrentUser | null): void {
  currentUser = user;
}

export function getCurrentUser(): CurrentUser | null {
  return currentUser;
}
